(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  if (!mobile.matches) return;
  const images = [...document.querySelectorAll('.comely-guide-content img, .hdt-article-content img')];
  if (!images.length) return;
  const dialog = document.createElement('dialog');
  dialog.className = 'cl-blog-zoom';
  dialog.setAttribute('aria-label', 'Image preview');
  dialog.innerHTML = '<button type="button" aria-label="Close image preview">×</button><img alt="" draggable="false">';
  document.body.append(dialog);
  const preview = dialog.querySelector('img');
  dialog.querySelector('button').onclick = () => dialog.close();
  dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
  const protect = node => {
    node.addEventListener('contextmenu', e => e.preventDefault());
    node.addEventListener('dragstart', e => e.preventDefault());
    node.addEventListener('copy', e => e.preventDefault());
  };
  protect(dialog);
  images.forEach(img => {
    img.draggable = false;
    img.classList.add('cl-blog-zoom-trigger');
    img.tabIndex = 0;
    img.setAttribute('role', 'button');
    img.setAttribute('aria-label', 'Enlarge image: ' + (img.alt || 'Article image'));
    protect(img);
    const link = img.closest('a');
    if (link && /\.(png|jpe?g|webp|gif)(\?|$)/i.test(link.href)) {
      link.removeAttribute('href');
      link.removeAttribute('target');
      protect(link);
    }
    const open = e => {
      if (!mobile.matches) return;
      e.preventDefault();
      e.stopPropagation();
      preview.src = img.currentSrc || img.src;
      preview.alt = img.alt;
      dialog.showModal();
    };
    img.addEventListener('click', open);
    img.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') open(e); });
  });
})();
